import { motion, Variants } from "framer-motion";
import styled, { css } from "styled-components";
import { Box } from "../Box";
import ButtonText from "../buttons/ButtonText";
import { Chip } from "../Chip";
import Icon from "../Icon";
import { Text } from "../Text";

interface PTOverlayInfoProps {
  isOpen: boolean;
  onToggleClick: () => void;
  heading: string;
  copy: string;
}

const Wrapper = styled(motion.div)`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 420px;
`;

const Block = styled.div`
  background-color: ${({ theme }) => theme.colors.pinkLight};
`;

const Header = styled(motion.div)<{ $brTop: string | undefined }>`
  position: absolute;
  bottom: 100%;
  right: 0;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.pinkLight};
  ${({ $brTop }) =>
    !$brTop
      ? css`
          border-radius: 20px 20px 0 0;
        `
      : css`
          border-radius: 20px 0 0 0;
        `}
  padding: 16px 64px 8px 24px;
  cursor: pointer;
`;

const Toggle = styled(motion.button)`
  position: absolute;
  bottom: calc(100% - 32px);
  right: 0;
  width: 64px;
  height: 64px;
  background-color: ${({ theme }) => theme.colors.pinkLight};
  border-radius: 32px 32px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  border: none;
  cursor: pointer;
`;

const Body = styled.div`
  min-height: 200px;
  padding: 16px 24px 32px;
`;

const wrapperVariants: Variants = {
  open: { y: "16px" },
  closed: { y: "100%" },
};

export const PTOverlayInfo: React.FC<PTOverlayInfoProps> = ({
  isOpen,
  onToggleClick,
  heading,
  copy,
}) => {
  return (
    <Wrapper
      id="overlay-info"
      variants={wrapperVariants}
      initial={false}
      animate={isOpen ? "open" : "closed"}
      transition={{ duration: 0.2, type: "tween" }}
    >
      <Block>
        <Header
          $brTop={copy}
          onTap={copy ? onToggleClick : () => {}}
          whileHover="hover"
          whileTap="tap"
        >
          {copy && (
            <Toggle variants={{ hover: { y: -4 }, tap: { y: 0 } }}>
              <Icon icon={!isOpen ? "expandLess" : "expandMore"} />
            </Toggle>
          )}
          <Text variant="h4">{heading}</Text>
        </Header>
        <Body>
          <Chip color="melonLight">
            <Text variant="h5">1970s</Text>
          </Chip>
          <Box mt={2}>
            <Text>{copy}</Text>
          </Box>
          <Box fontWeight={700} textAlign="right" mt={3}>
            {/* <ButtonText icon="reply">Share</ButtonText> */}
          </Box>
        </Body>
      </Block>
    </Wrapper>
  );
};
